namespace Gamification.Gamification {
    export enum ApiScriptClassificheOrdinamentiEnum {
        Punteggio_Globale = 1,
        Punteggio_EXP = 2,
        Punteggio_Relativo_Ad_Un_Esperienza = 3
    }
    Serenity.Decorators.registerEnumType(ApiScriptClassificheOrdinamentiEnum, 'Gamification.Gamification.ApiScriptClassificheOrdinamentiEnum');
}
